<template>
  <div style="padding: 15px">
    <div style="margin-bottom: 20px;">
      <vxe-table
        ref="xTable"
        border
        resizable
        stripe
        highlight-current-row
        highlight-hover-row
        row-id="id"
        height="350"
        show-footer
        :footer-method="footerMethod"
        :loading="loading"
        :data="tableData"
      >
        <vxe-table-column
          field="orderCode"
          title="运输单号"
          min-width="300"
        />
        <vxe-table-column
          field="shipperDeliveryFee"
          title="运费"
          min-width="130"
        />
        <vxe-table-column
          field="placeOfShipment"
          title="装货地址"
          min-width="300"
        />
        <vxe-table-column
          field="placeOfReceipt"
          title="收货地址"
          min-width="300"
        />
        <vxe-table-column
          field="gmtCreated"
          title="运单创建时间"
          min-width="300"
        />
      </vxe-table>
    </div>
    <div style="margin-bottom: 20px;">
      <el-form
        ref="form"
        label-width="100px"
        :model="form"
        :rules="rules"
      >
        <el-row>
          <el-col :span="10">
            <div class="custom-grid">
              <el-form-item
                prop="invoiceImg"
                label="发票图片"
              >
                <el-upload
                  v-model="form.invoiceImg"
                  :headers="headers"
                  class="avatar-uploader"
                  :action="uploadUrl"
                  :show-file-list="false"
                  :on-success="(res, file) => uploadSuccess(res, file)"
                  :before-upload="beforeAvatarUpload"
                >
                  <img
                    v-if="form.invoiceImg"
                    :src="form.invoiceImg"
                    class="avatar"
                  >
                  <i
                    v-else
                    class="el-icon-plus avatar-uploader-icon"
                  />
                </el-upload>
              </el-form-item>
              <!-- <div style="margin-top: 8px;">发票图片</div> -->
            </div>
          </el-col>
          <el-col :span="10">
            <el-form-item
              label="发票号码"
              prop="invoiceNumber"
            >
              <el-input v-model="form.invoiceNumber" maxlength="20" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="funcSubmit"
        >
          开票
        </el-button>
      </div>
    </div>
    <div />
  </div>
</template>
<script>
import { invoiceSimpleDetail, drawInvoice } from "@/api/invoice";
import { getToken } from '@/utils/auth';
export default {
  name: "InvoiceMakeOut",
  data() {
    return {
      uploadUrl: this.BASE_API_URL + "ntocc-tps-api/fileUpload",
       headers:{
        Authorization:'Bearer ' + getToken(),
        deviceId:'0000000000'
       },
      loading: false,
      tableData: [],
      fileList: [],
      emptyForm: {},
      invoice: {},
      form: {
        invoiceNumber: "",
        code: "",
        invoiceImg: ""
      },
      rules: {
        invoiceNumber: [
          { required: true, message: "请输入发票号码", trigger: "blur" }
        ],
        // invoiceImg: [
        //   { required: true, message: "请上传发票图片", trigger: "blur" }
        // ],
      }
    };
  },
  created() {
    // 保存空表单对象
    this.emptyForm = JSON.parse(JSON.stringify(this.form));
  },
  methods: {
    // 获取页面信息
    getInfo(code) {
      this.form = JSON.parse(JSON.stringify(this.emptyForm))
      this.form.code = code;
      invoiceSimpleDetail({ code }).then(response => {
        this.tableData = response.data.detailList;
      });
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/bmp" ||
        file.type === "image/png";
      const isLtnM = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG,BMP,PNG 格式!");
        return false
      }
      if (!isLtnM) {
        this.$message.error("上传图片大小不能超过 10MB!");
        return false
      }
      // 获取token值，实时获取
      this.headers.Authorization = 'Bearer ' + getToken()
      return isJPG && isLtnM;
    },
    // 上传图片
    uploadSuccess(res, fileList) {
      if(res.status==500){
        this.$message.error(res.msg)
      } else {
        this.form.invoiceImg = res.data;
      }
    },
    // 费用合计
    footerMethod({ columns, data }) {
      const sums = [];
      columns.forEach((column, columnIndex) => {
        if (columnIndex === 0) {
          sums.push("费用合计");
        } else {
          let sumCell = "-";
          if (column.property === "shipperDeliveryFee") {
            sumCell = this.$XEUtils.sum(data, column.property);
          }
          sums.push(sumCell);
        }
      });
      return [sums];
    },
    // 确认
    funcSubmit() {
      if(!this.form.invoiceImg){
        this.$message.error("请上传发票图片");
        return
      }
       this.$refs["form"].validate(valid => {
        if (valid) {
        const rLoading = this.openLoading();
        drawInvoice(this.form).then(response => {
          rLoading.close();
          this.$message({ message: response.msg, type: "success" });
          this.$emit("hideModel");
          this.tableData = [];
          this.fileList = [];
          this.form = this.emptyForm;
        });
        }
        // else {
        //   this.$message.error("必选项为空或格式不正确");
        // }
       })
    }
  }
};
</script>
<style lang="scss" scoped>
  .dialog-footer {
    margin: 15px 0 15px 0;
    width: 175px;
    float: right;
  }
  .custom-grid {
    display: inline-block;
    font-size: 14px;
    color: #8c939d;
    margin-right: 20px;
  }
  .avatar-uploader ::v-deep.el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader-icon {
    box-sizing: border-box;
    font-size: 28px;
    color: #8c939d;
    width: 148px;
    height: 148px;
    line-height: 148px;
    text-align: center;
    border-width: 1px;
    border-style: dashed;
    border-color: #c0ccda;
  }
  .avatar-uploader-icon:hover {
    border-color: #409eff;
  }
  .avatar {
    width: 148px;
    height: 148px;
    display: block;
  }

</style>
